import React, { useEffect, useState } from "react";
import Idheading from "../components/Idheading";
import TicketDetailsContent from "../components/TicketDetailsContent";
import TicketDetailsHeading from "../components/TicketDetailsHeading";
import ConversationContainer from "../components/ConversationContainer";
import StatusHistoryContainer from "../components/StatusHistoryContainer";
import TicketStatusContainer from "../components/TicketStatusContainer";
import useTicket from "../hooks/useTicket";
import { toast } from "react-toastify";
import { useAtom } from "jotai";
import {
  conversationsAtom,
  currentPageAtom,
  messageCountAtom,
  statusHistoryAtom,
  ticketAtom,
  workOrderIDAtom,
} from "../store";
import { useLocation } from "react-router-dom";
import { useLoadingContext } from "react-router-loading";
import { useNavigate } from "react-router-dom";
import useConversation from "../hooks/useConversation";

const StatusHistory = () => {
  const { fetch } = useTicket();
  const [ticketData, setTicketData] = useAtom(ticketAtom);
  const [, setStatusHistory] = useAtom(statusHistoryAtom);
  const location = useLocation();
  const loadingContext = useLoadingContext();
  const navigate = useNavigate();

  const [workOrderID] = useAtom(workOrderIDAtom);
  const [count] = useAtom(messageCountAtom);
  const { fetchMessages } = useConversation({ count: count });
  const [page, setPage] = useAtom(currentPageAtom);
  const [messages, setMessages] = useState<any[]>([]);
  const [conversations, setConversations] = useAtom(conversationsAtom);
  const [isFetchingOlderConversations, setIsFetchingOlderConversations] =
    useState(false);
  const second = 1000;
  const minute = second * 60;
  const pollingTime = minute * 0.5;

  // polling to refetch at intervals but only if there are conversations
  useEffect(() => {
    let polling: NodeJS.Timer;
    if (workOrderID) {
      if (messages.length) setMessages([]);

      fetchMessages.fetch({ page: page });

      polling = setInterval(() => {
        fetchMessages.fetch({ page: page });
      }, pollingTime);
    } else {
      setConversations([]);
    }

    return () => {
      clearInterval(polling);
      setConversations([]);
    };
  }, [ticketData, page, workOrderID]);

  useEffect(() => {
    const duplicatesArr = [...messages, ...conversations];
    duplicatesArr.sort((a, b) => a.id - b.id);
    const cache: any = {};
    duplicatesArr.forEach((item: any) => {
      if (!cache[item.id]) {
        cache[item.id] = item;
      }
    });

    const noDuplicatesArr = Object.values(cache).filter(
      (item: any) => item.work_order_id === workOrderID
    );
    setMessages([...noDuplicatesArr]);
  }, [conversations]);

  useEffect(() => {
    if (isFetchingOlderConversations && !fetchMessages.loading) {
      setIsFetchingOlderConversations(false);
    }
  }, [fetchMessages.loading]);

  const handleListner = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    fetch(+params.ticketID, params.email, {
      onError: (error) => {
        console.error(error);
      },
      onSuccess: (data, success) => {
        if (data.status === 404) {
          setTicketData(null);
          setStatusHistory(null);
          return toast.error(data.message);
        }
        if (success === true) {
          setTicketData(data?.ticket_details);
          setStatusHistory(data?.status_history);
          loadingContext.done();
        } else if (success === false) {
          setTicketData(null);
          setStatusHistory(null);
          navigate("/");
          toast.error(data.message);
          loadingContext.done();
        }
      },
    });
  };

  useEffect(() => {
    handleListner();
  }, [location]);

  return (
    <div className="parent-container contain-expand">
      <Idheading />
      <section className="status-snippets-container contain-expand">
        <TicketStatusContainer />
      </section>

      <section className="ticket-details-container">
        <div>
          <p>Here are the information about your task</p>
          <TicketDetailsHeading />

          <TicketDetailsContent />
        </div>
      </section>

      <section className="convo-history-container">
        <div>
          <ConversationContainer
            messages={messages}
            isFetchingOlderConversations={isFetchingOlderConversations}
            setIsFetchingOlderConversations={setIsFetchingOlderConversations}
          />

          <StatusHistoryContainer />
        </div>
      </section>
    </div>
  );
};

export default StatusHistory;
